// Original code by Dan Abramov
// https://overreacted.io/making-set-interval-declarative-with-react-hooks

import { useEffect, useRef } from 'react'

const useInterval = (callback: Function, delay: number) => {
  const savedCallback: any = useRef()

  //remember the latest function
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    const tick = () => {
      savedCallback.current()
    }
    if (delay !== null) {
      let id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}

export default useInterval
